<template>
  <DashboardPage>
    <PageBreadcrumb
      :crumbs="[{
        label: $t('profile.profile')
      }]"
    />

    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
      <a
        href="#"
        class="btn btn-cta"
        @click="changePassword"
      >
        {{ $t('profile.change_password') }}
      </a>
    </div>
  </DashboardPage>
</template>

<script setup>
import DashboardPage from '@/components/DashboardPage.vue';
import PageBreadcrumb from '@/components/PageBreadcrumb.vue';
import useAxios from '@/composables/axios';

const axios = useAxios()

const changePassword = function() {
    axios.get('/profile/passwordChangeUrl?returnUrl=' + encodeURIComponent(window.location.href)).then(resp => {
      window.location.href = resp.data.url;
    }).catch(() => {
    });
}
</script>